export default function TableAndFiltersContainer({
  filtersComponent,
  columnSelectionComponent,
  searchComponent,
  actionsComponent,
  children,
}: {
  filtersComponent: JSX.Element;
  columnSelectionComponent: JSX.Element;
  searchComponent: JSX.Element;
  /** Extra buttons, rendered at the end of the search row. */
  actionsComponent?: JSX.Element;
  children: JSX.Element;
}) {
  return (
    <>
      <div className="border border-black-150 rounded-4xl">
        <div className="flex border-b border-b-black-150 p-3 gap-x-2">
          {searchComponent}

          {actionsComponent && (
            <div className="flex ml-auto gap-x-2">{actionsComponent}</div>
          )}
        </div>
        <div className="flex p-3 items-start justify-between gap-x-2">
          {filtersComponent}
          {columnSelectionComponent}
        </div>
      </div>
      {children}
    </>
  );
}
